module.exports = __webpack_public_path__ + "media/assets/order-c148674a8f6074baf6d1f67436932d71.svg";